import { useSSEAdapter as e } from "./adapter/SSEAdapterContext.mjs";
import t, { createContext as n, useCallback as r, useContext as i, useEffect as a, useRef as o } from "react";
import { jsx as s } from "react/jsx-runtime";
import { useAuth as c } from "@maat/store-auth";
//#region src/SSEProvider.tsx
var l = n(null), u = ({ children: n }) => {
	let { isAuthenticated: i } = c(), u = e(), d = o(/* @__PURE__ */ new Map()), [, f] = t.useReducer((e) => e + 1, 0), p = r((e) => {
		let t = d.current.get(e);
		t?.handle && (t.handle.close(), t.handle = null, t.status = "disconnected");
	}, []), m = r(() => {
		for (let e of d.current.keys()) p(e);
		d.current.clear(), f();
	}, [p]);
	a(() => (i || m(), () => {
		m();
	}), [i, m]);
	let h = r((e, t) => {
		if (!i || t.handle) return;
		t.status = "connecting", f();
		let n = u.open(t.url, {
			withCredentials: !0,
			onOpen: () => {
				t.status = "connected", f();
			},
			onError: () => {
				t.status = "connecting", f();
			}
		});
		t.handle = n;
		for (let [r, i] of t.handlers) n.addEventListener(r, (t) => {
			try {
				let e = JSON.parse(t);
				for (let t of i) t(e);
			} catch {
				console.error(`[SSE:${e}] Failed to parse ${r}:`, t);
			}
		});
	}, [i, u]), g = r((e, t) => {
		let n = d.current.get(e);
		return n || (n = {
			url: t,
			handle: null,
			status: "disconnected",
			handlers: /* @__PURE__ */ new Map()
		}, d.current.set(e, n)), {
			status: n.status,
			on: (t, r) => (n.handlers.has(t) || n.handlers.set(t, /* @__PURE__ */ new Set()), n.handlers.get(t).add(r), n.handle && n.handle.addEventListener(t, (n) => {
				try {
					r(JSON.parse(n));
				} catch {
					console.error(`[SSE:${e}] Failed to parse ${t}:`, n);
				}
			}), h(e, n), () => {
				n.handlers.get(t)?.delete(r);
			})
		};
	}, [h]), _ = r((e) => d.current.get(e)?.status ?? "disconnected", []), v = t.useMemo(() => ({
		connect: g,
		getStatus: _
	}), [g, _]);
	return /* @__PURE__ */ s(l.Provider, {
		value: v,
		children: n
	});
}, d = () => {
	let e = i(l);
	if (!e) throw Error("useSSE must be used inside <SSEProvider>");
	return e;
};
//#endregion
export { u as SSEProvider, d as useSSE };
